import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { ValueChange } from "./baseDetails";

export default function modelDataValueUpdateDetails({ row }) {
    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <ValueChange oldValue={row.old_value} newValue={row.new_value} />
        </ModelDataValueUpdateDetailsBase>
    );
}
